import React from 'react'

export default function GreenTick({color}) {
  return (
    <svg width="20" height="15" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1 7.42857L7 13.8571L19 1" stroke={color ? color : "#52CBC4"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                        </svg>
  )
}
